<template>


<div class="font-ww-regular">
    <SectionFrostedCookieBuilderHeader />
    <SectionFrostedCookieBuilderTextWhitImage />
    <SectionFrostedCookieBuilderTextIconsImage />
    <SectionFrostedCookieBuilderImageTextList />
    <SectionFrostedCookieBuilderTextWithImages />
    <SectionFrostedCookieBuilderBgTexImage />
    <SectionFrostedCookieBuilderSwatchesType3 />
    <!-- <SectionFrostedCookieBuilderLogos /> -->
    <SectionFrostedCookieBuilderTextWhitImages2 />
    <SectionFrostedCookieBuilderCustomersReviews />
    <SectionFrostedCookieBuilderCustomersImages />
    <SectionFrostedCookieBuilderFooter />
</div>




</template>

<script setup>


useSeoMeta({
  layout:() => "default",
  title: () => "Lifeboost Frosted Sugar Cookie Coffee - Sweet, Buttery Aroma Meets Rich Arabica",
  description: () => "Indulge in the comforting blend of Lifeboost's Frosted Sugar Cookie Coffee. Experience the familiar sweetness of frosted sugar cookies combined with the bold, rich flavor of single origin, shade-grown Arabica beans. A cup that brings simple pleasures and incredibly satisfying flavor, crafted from premium, sustainably sourced coffee beans. Enjoy the essence of sweet, velvety vanilla and creamy butter in every sip. Perfect for those who appreciate the finer, sweeter things in life."
})


</script>